import React from 'react';

import Flex from '~/common/components/Flex';
import type { ComponentTypeProps } from '~/common/components/QuestionLibrary/types/component';

import QuestionLibraryMapper from '../mappers/QuestionLibraryMapper';
import { useConditionsEvaluator } from '../utils/useConditionsEvaluator';
import QuestionResolutionWrapper from './utilityComponents/QuestionResolutionWrapper';

type FlexContainerProps = Readonly<{
  component: ComponentTypeProps & {
    direction?: React.ComponentProps<typeof Flex>['flexDirection'];
    justify?: React.ComponentProps<typeof Flex>['justifyContent'];
    align?: React.ComponentProps<typeof Flex>['alignItems'];
    wrap?: React.ComponentProps<typeof Flex>['flexWrap'];
    hasBottomBorder?: boolean;
    resolutions?: object[];
    padding?: string;
  };
}>;

export default function FlexContainer({ component }: FlexContainerProps) {
  const {
    children,
    direction = 'row',
    justify = 'flex-start',
    align = 'center',
    wrap = 'wrap',
    padding = '0 0 0.25rem 0',
    hasBottomBorder = true,
    conditions = {},
    resolutions = [],
    ...rest
  } = component;

  const { isVisible } = useConditionsEvaluator(conditions);

  return (
    <QuestionResolutionWrapper
      resolutions={resolutions}
      hasBottomBorder={hasBottomBorder}
      isVisible={isVisible}
      padding={padding}
    >
      <Flex
        flexDirection={direction}
        justifyContent={justify}
        alignItems={align}
        flexWrap={wrap}
        width={'100%'}
        {...rest}
      >
        {children.map((child) => (
          <QuestionLibraryMapper
            key={child.name}
            component={child}
            isParentShowing={isVisible}
          />
        ))}
      </Flex>
    </QuestionResolutionWrapper>
  );
}
